<div *ngIf="block"
    class="card overflow-hidden {{block && (!block.immagine && block.link_card && !block.label_cta)  ? 'border-custom' : 'border'}} no-print"
    [ngClass]="{'pb-5': !block.label_cta}" [class.cursor-pointer]="!block.label_cta && block.link_card"
    (click)="!block.label_cta && navigateTo()" role="button" tabindex="0">
    <div class="card__img-container" role="button" tabindex="0">
        <img loading="lazy" *ngIf="block.immagine" [src]="domainWebsite + extractImageSrc(block.immagine)"
            class="card__img-container__image" [alt]="block.testo_alt">
        <img loading="lazy" *ngIf="block.immagine_icona" [src]="domainWebsite + extractImageSrc(block.immagine_icona)"
            [alt]="block.testo_alt" class="card__img-container__icon">
    </div>
    <div class="card__overline-container" tabindex="0"
        [ngStyle]="{'margin-top': (!block.immagine && !block.immagine_icona) && block.overline ? '32px' : '0'}">
        <p *ngIf="block.overline" class="m-0 ls-label-small-semibold text-neutral-60 text-uppercase" [innerHTML]="block.overline"></p>
    </div>
    <div class="card__card-body h-100 d-flex flex-column justify-content-between position-relative" style="gap: 40px" tabindex="0">
        <div [class.mt-3]="!block.immagine">
            <h2 *ngIf="block.titolo" class="card__card-body__card-title ls-h3-item-title text-brand-10 card-title mb-3"
                [innerHTML]="block.titolo"></h2>
            <div *ngIf="block.descrizione" class="card__card-body__card-text ls-p text-neutral-30 card-text"
                [innerHTML]="block.descrizione"></div>
        </div>
        <div class="card__card-body__cta d-flex line-discover-with-icon" *ngIf="block.link_card && block.label_cta">
            <p *ngIf="!isLinkEsternal" class="m-0 pb-1 ls-label-medium-semibold text-brand-40 text-uppercase"
                [innerHTML]="block.label_cta" [routerLink]="navigationService.splitUrlRouterLink(block.link_card.url).path" [queryParams]="navigationService.splitUrlRouterLink(block.link_card.url).queryParams"></p>
            <span *ngIf="isLinkEsternal" (click)="externalUrl($event,block.link_card.url)">
                <p class="m-0 pb-1 ls-label-medium-semibold text-brand-40 text-uppercase" [innerHTML]="block.label_cta">
                </p>
            </span>
            <i class="fa-solid fa-arrow-right text-brand-40" aria-hidden="true"></i>
        </div>
    </div>
</div>
<app-sample-print 
    [imageUrl]="block.immagine ? (domainWebsite + extractImageSrc(block.immagine)) : ''"
    [iconUrl]="block.immagine_icona ? (domainWebsite + extractImageSrc(block.immagine_icona)) : ''"
    [subtitle]="block.titolo"
    [description]="block.descrizione">
</app-sample-print>